import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvb7a5sg8c: FaireProductEntity = {
  token: "p_pvb7a5sg8c",
  type: "product",
  name: "Polychrome Jasper Crystal Hearts, Ethically Sourced Valentines Day Gifts",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/b99ca5cc74aa7246ba224719974286e64779fa4b37e6a7fef0f3bb461c9f71fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e61ff295414d038f09041a53d3a75f14a4c6632de421d40d65abb22ff46fd359.jpeg",
    "https://cdn.faire.com/fastly/a12ec6493e900f05790c7cf25a46dbe772ad3777a7fa811950d031ea16fa8ccb.jpeg",
    "https://cdn.faire.com/fastly/671a9b8be54a20888b546e6a0247749f617f6ca2a12db76f55ba1e89ff86ddcc.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Delight your customers this Valentine’s season with Polychrome Jasper Hearts, a stunning fusion of beauty and energy. Perfect for boutiques, gift shops, and metaphysical stores, these hand-carved treasures symbolize grounding love and balance, making them the ideal gift for heartfelt moments.\n\nSymbol of Connection: Celebrate relationships with a heart-shaped token of enduring love and stability.\nGrounding Energy: Help customers reconnect with nature’s tranquility during the hectic holiday season.\nVisual Delight: Add a touch of artistic charm with jasper’s vibrant swirls and earthy tones.\nVersatile Appeal: Perfect for Valentine’s gifts, home décor, or spiritual practices.\nBoost Sales: Cater to growing demand for meaningful, eco-conscious, and wellness-inspired products.\nEthically Sourced: Sustainably obtained to meet your customers’ conscious shopping preferences.\n",
  tags: [],
  msrpDollars: 13,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:30.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
